import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { PaymentsService } from './services/payments.service';
import { CreditsOrderComponent } from './credits-order/credits-order.component';
import { PaymentsRoutingModule } from './payments-routing.module';

@NgModule({
  imports: [CommonModule, CoreModule, PaymentsRoutingModule],
  declarations: [CreditsOrderComponent],
  exports: [CreditsOrderComponent],
  providers: [PaymentsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PaymentsModule {}
